const initialComplaintData = () => ({
    // General
    id: null,
    complaintTypeId: 1,
    complaintStatusId: 1,
    priority: false,

    // Details Tab
    complaintTypeName: 'Reklamacja wewnętrzna',
    complaintProductionDepartmentId: null,
    productionSiteGroupId: null,
    productionProcessId: null,
    machineId: null,
    jobNumber: null,
    complaintOrderComplaint: [],
    complaintOrderComplaintDetails: [],
    discrepancyDescription: null,
    discrepancyCatcher: null,
    discrepancyCatcherId: null,
    complaintProductDescription: null,
    responsibleUsersIds: [],
    errorCodeGroupId: null,
    errorCodeId: null,
    defects: [],
    complaintWayOfProceeding: {
        complaintWayOfProceedingId: null,
        value: null
    },

    // Attachments Tab
    complaintAttachment: [],

    // Causes Tab
    discrepancyCause: null,
    complaintErrorId: null,

    // Recommendations Tab
    correctiveMeasures: null,

    // Temporary fields for successful complaint save - will be moved up in next stories
    createdAt: null,
    scaleAmount: null,
    scalePercent: null,
    complaintClassificationId: null,
    inNewOrderIn: null,
    outage: null,
    newIn: null,
    materialTypeId: null,
    formatTrimmedIn: null,
    stockAmount: null,
    unitTypeId: null,
    reprintJobNumber: null,
    reprintJobPlateNumber: null,
    reprintAmount: null,
    responsiblePersonRead: null,
    inCurrentOrderCb: false,
    inNewOrderCb: false,
    fromAdvertisingOrderCb: false,
    newCb: false,
    formatTrimmedCb: false,
    discountCb: false,
    costWithTransport: 0,
    costWithDiscount: 0,
    complaintCost: 0,
    reprint: false,
    createdStopCards: [],
    responsiblePerson: [],
    ordersData: [],
    creator: {
        id: null,
    },
})

export default initialComplaintData
